import { InspectionLocationInfo, LocationInfo } from "./types";

export function parseDMS(value: string | null) {
    if (!value) {
        return null;
    }
    const regex =
        /(\d+)[°]\s*(\d+)'\s*([\d.]+)"\s*([NS])\s+(\d+)[°]\s*(\d+)'\s*([\d.]+)"\s*([EW])/i;

    const match = value.trim().match(regex);

    if (!match) {
        return null;
    }

    const [
        _,
        latDeg,
        latMin,
        latSec,
        latDir,
        lngDeg,
        lngMin,
        lngSec,
        lngDir
    ] = match;

    let lat =
        Number(latDeg) +
        Number(latMin) / 60 +
        Number(latSec) / 3600;

    let lng =
        Number(lngDeg) +
        Number(lngMin) / 60 +
        Number(lngSec) / 3600;

    if (latDir.toUpperCase() === 'S') {
        lat *= -1;
    }

    if (lngDir.toUpperCase() === 'W') {
        lng *= -1;
    }

    return { lat, lng };
}

export function toDMS(value: number, type: 'lat' | 'lng') {
    const absolute = Math.abs(value);

    const degrees = Math.floor(absolute);

    const minutesNotTruncated = (absolute - degrees) * 60;
    const minutes = Math.floor(minutesNotTruncated);

    const seconds =
        ((minutesNotTruncated - minutes) * 60).toFixed(1);

    let direction = '';

    if (type === 'lat') {
        direction = value >= 0 ? 'N' : 'S';
    } else {
        direction = value >= 0 ? 'E' : 'W';
    }

    return `${degrees}°${minutes.toString().padStart(2, '0')}'${seconds.padStart(4, '0')}"${direction}`;
}

export function newLocationInfo(): LocationInfo {
    return {
        unit: null,
        building_name: null,
        city_id: null,
        country_id: null,
        zip_code: null,
        latitude: null,
        longitude: null,
        streets: [],
        localities: [],
        administrative_areas: [],
        location_surrounding: null
    }
}

export function newInspectionLocationInfo(): InspectionLocationInfo {
    const locationInfo = newLocationInfo()
    return {
        ...locationInfo,
        distance_to_the_sea: null,
        elevation_from_sea: null
    }
}

export function address(locationInfo: LocationInfo): string {
    return ''
}